import React from 'react'
import type { Icon } from 'shared/utils'

const Cancel = (props: Icon) => {
    const {
        color = 'black',
        size = 100,
        className = 'cancel',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 100 100"
            fill={color}
            {...otherProps}>
            <path d="M87.492 12.633c-5.271-5.272-13.82-5.272-19.092 0L50.063 30.971 31.725 12.633c-5.271-5.272-13.82-5.272-19.092 0s-5.272 13.82 0 19.092l18.338 18.338L12.633 68.4c-5.272 5.272-5.272 13.819 0 19.092 2.636 2.636 6.091 3.954 9.546 3.954s6.91-1.318 9.546-3.954l18.338-18.338L68.4 87.492c2.636 2.636 6.091 3.954 9.546 3.954s6.91-1.318 9.546-3.954c5.272-5.272 5.272-13.819 0-19.092L69.154 50.062l18.338-18.338c5.273-5.271 5.273-13.819 0-19.091z" />
        </svg>
    )
}

export { Cancel }
